<script lang="ts">
  // @ts-ignore
  import manifest from "../../manifest.json";
  import GNavBar from "./GNavBar.svelte";
  import GPreview from "./GPreview.svelte";
  import GToolbar from "./GToolbar.svelte";
  import Search from "./Search.svelte";

  let tags = [];
  let options = {
    components: ["video", "image", "review", "timeline", "rating", "marquee"],
    options: ["darkMode"],
  };

  console.log("---- manifest ----");
  console.log(manifest);
  console.log("------------------");

  const version = manifest.stable;
  let templates = manifest.templates.filter(
    (el) => !(el.live === false) && el.group !== "base"
  );

  $: gallery = updateGallery(tags);
  $: templateCount = Object.keys(gallery || {}).reduce(
    (acc, key) => acc + gallery[key].length,
    0
  );

  const updateGallery = (tags) => {
    let newGallery = {};

    if (tags.length === 0) {
      templates.forEach((element) => {
        if (!(element.group in newGallery)) {
          newGallery[element.group] = [];
        }
        newGallery[element.group].push(element);
      });
      return newGallery;
    }

    templates.forEach((element) => {
      const isFilterMatch = element.tags.some((tag) => tags.includes(tag));

      if (isFilterMatch) {
        if (!(element.group in newGallery)) {
          newGallery[element.group] = [];
        }
        newGallery?.[element.group]?.push(element);
      }
    });
    return newGallery;
  };
</script>

<main>
  <GNavBar />
  <GToolbar />
  <Search bind:tags {options} {templateCount} />
  <div class="gallery-container">
    {#each Object.keys(gallery) as key (key)}
      <div class="row" id={key}>
        <div class="gallery">
          {#each gallery[key] as template (template.folder)}
            <GPreview {version} {template} section={key} />
          {/each}
        </div>
        <div class="labels">
          <a href="#{key}">
            <h1>{key}</h1>
          </a>
        </div>
      </div>
      <hr />
    {/each}
  </div>
</main>

<style>
  main:last-child {
    padding-bottom: 50vh;
  }

  .gallery-container {
    margin-top: 150px;
  }

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    scroll-margin-top: 75px;
    /* overscroll-behavior: contain; */
  }

  .gallery {
    /* width: 90vw; */
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    overflow-x: scroll;
    padding: 25px;
    /* overscroll-behavior: contain; */
    /* height: calc((100vh - 75px)); */
  }

  hr {
    opacity: 0.07;
  }

  .labels {
    text-transform: uppercase;
    text-align: center;
    flex-shrink: 0;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid rgba(255, 255, 255, 0.07);
    background-color: #171819a0;
    min-width: 60px;
    width: 10vw;
    max-width: 150px;
  }

  @media only screen and (max-width: 600px) {
    .labels {
      display: none;
    }
  }

  hr {
    margin: 0px;
    padding: 0px;
  }

  h1 {
    position: sticky;
    font-size: max(1.1rem, 2vw);
    top: 75px;
    height: 5vh;
    z-index: 1;
    position: -webkit-sticky;
    opacity: 0.6;
    font-weight: 300;
    min-height: 60px;
    height: 10vw;
    max-height: 150px;
    /* background-color: rebeccapurple; */
    min-width: 60px;
    width: 10vw;
    max-width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  a {
    color: unset;
    text-decoration: none;
  }
</style>
